// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2aab73a8","453":"4d42930f","455":"0c8f047b","977":"3daa3063"}[chunkId] + ".chunk.js";
};